<template>
  <TransitionRoot as="template" :show="props.showModal">
    <Dialog as="div" class="relative z-50" @close="$emit('close-modal')">
      <TransitionChild
        as="template"
        enter="ease-out duration-300"
        enter-from="opacity-0"
        enter-to="opacity-100"
        leave="ease-in duration-200"
        leave-from="opacity-100"
        leave-to="opacity-0"
      >
        <div
          class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"
        />
      </TransitionChild>
      <div class="fixed inset-0 z-10 overflow-y-auto">
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <TransitionChild
            as="template"
            enter="ease-out duration-300"
            enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enter-to="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leave-from="opacity-100 translate-y-0 sm:scale-100"
            leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          >
            <DialogPanel
              class="relative transform overflow-auto rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-11/12 sm:max-w-5xl sm:p-6 max-h-[calc(100vh-200px)]"
            >
              <div
                class="my-3 text-center sm:mt-0 sm:text-left flex flex-wrap gap-4 items-center justify-between border-b border-gray-200 pb-4"
              >
                <DialogTitle
                  as="h3"
                  class="text-lg font-semibold leading-6 text-gray-900"
                  >{{ props.modalTitle }}</DialogTitle
                >
                <i
                  @click="$emit('close-modal')"
                  class="text-2xl font-bold fas fa-close cursor-pointer"
                >
                </i>
              </div>
              <div class="mt-4 w-full">
                <slot />
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script setup lang="ts">
import { defineProps, defineEmits } from "vue";
import {
  Dialog,
  DialogPanel,
  DialogTitle,
  TransitionChild,
  TransitionRoot,
} from "@headlessui/vue";

const props = defineProps({
  showModal: {
    type: Boolean,
    required: true,
  },
  modalTitle: {
    type: String,
    required: true,
  },
  fitContent: {
    type: Boolean,
    required: false,
    default: false,
  },
});

const emit = defineEmits(["close-modal"]);
</script>
